export const getLocalTime = (date: Date): Date => {
  const typedDate = new Date(date);
  // convert offset to MS and make negative so the timezone difference is correctly considered
  const timezoneOffset = typedDate.getTimezoneOffset() * -60000;
  const msSinceEpoch = typedDate.getTime();

  return new Date(msSinceEpoch + timezoneOffset);
};
